import React, { useState, useEffect, useContext } from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { APIContext } from '../../Contexts/APIContext';
import { SelectModal } from '../SelectModal';


const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IScorecardTemplateChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    showOnReport?: boolean;

}

export default function ScorecardTemplateChip({ showOnReport, filterName, onSelect, title, client, currentSelection, show, removeFilter, filterFlag, filterNames }: IScorecardTemplateChipProps) {
    const { get } = useContext(APIContext);
    const [options, setOptions] = useState<any>([]);

    useEffect(() => {
        getTemplates();
    }, [client]);

    const handleSelect = (name: any, value: any) => onSelect(name, value);

    const getTemplates = () => {
        get('QaiScorecardChallenge',
            `GetScorecardTemplates?client=${client}`,
            (data) => setOptions(data))
    }

    const handleDelete = () => {
        if (removeFilter) {
            removeFilter(filterFlag, filterNames);
        }
    }

    return (
        <>
            {show &&
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        {showOnReport &&
                            <AssessmentIcon sx={{ ml: 1 }} />
                        }
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{title}</Typography>
                        </Grid>
                        <SelectModal title={title} filterName={filterName} mutliSelect={false} currentSelection={currentSelection} onSelect={handleSelect} options={options} searchable={true} />
                        <Grid>
                            {removeFilter &&
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}><CancelIcon /></IconButton>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>
    );
}